import { render, staticRenderFns } from "./schoolAddClass.vue?vue&type=template&id=472c0b6b&scoped=true&"
import script from "./schoolAddClass.js?vue&type=script&lang=js&"
export * from "./schoolAddClass.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472c0b6b",
  null
  
)

export default component.exports